/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_ApproveInputs */

const en_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve`)
};

const fr_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver`)
};

const de_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen`)
};

const it_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvare`)
};

const ru_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Утвердить`)
};

const es_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar`)
};

const zh_cn2_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批准`)
};

const ja_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`承認する`)
};

const hi_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मंज़ूरी देना`)
};

const pt_pt2_context_menu_approve = /** @type {(inputs: Context_Menu_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar`)
};

/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Context_Menu_ApproveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_approve = /** @type {((inputs?: Context_Menu_ApproveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_ApproveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_approve(inputs)
	if (locale === "de") return de_context_menu_approve(inputs)
	if (locale === "it") return it_context_menu_approve(inputs)
	if (locale === "ru") return ru_context_menu_approve(inputs)
	if (locale === "es") return es_context_menu_approve(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_approve(inputs)
	if (locale === "ja") return ja_context_menu_approve(inputs)
	if (locale === "hi") return hi_context_menu_approve(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_approve(inputs)
	return en_context_menu_approve(inputs)
});